import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { businessAPI } from '../../services/apiServices';
import { Modal, Spinner } from '../../components/common/UI';

const QrCodeModal = ({ isOpen, onClose, businessId }) => {
  const { t } = useTranslation();
  const [qrCode, setQrCode] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    setLoading(true);
    const request = businessId
      ? businessAPI.generateBusinessQrCode(businessId)
      : businessAPI.generateQrCode();
    request
      .then(({ data }) => {
        setQrCode(data.data?.qrCode || data.qrCode);
      })
      .catch(() => setQrCode(null))
      .finally(() => setLoading(false));
  }, [businessId, isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('businessDetails.qrCodeTitle')} size="sm">
      <div className="py-4 text-center">
        <p className="mb-5 text-sm text-slate-500">
          {t('businessDetails.qrCodeHelp')}
        </p>
        {loading ? (
          <Spinner />
        ) : qrCode ? (
          <img
            src={qrCode}
            alt={t('businessDetails.qrCode')}
            className="mx-auto h-[200px] w-[200px] rounded-lg border border-slate-200"
          />
        ) : (
          <p className="text-sm font-medium text-red-600">{t('businessDetails.qrCodeError')}</p>
        )}
        {qrCode && (
          <p className="mt-4 text-sm text-slate-500">
            {t('businessDetails.qrCodeScan')}
          </p>
        )}
      </div>
    </Modal>
  );
};

export default QrCodeModal;
